module.exports = __webpack_public_path__ + "img/detalhe_01.b28c0ffe.svg";